import type * as React from "react";
import { cn } from "@/lib/utils";

interface DashboardLayoutProps {
	children: React.ReactNode;
	className?: string;
}

function DashboardLayout({ children, className }: DashboardLayoutProps) {
	return (
		<main
			id="main-content"
			data-dashboard-scroll-container
			className={cn(
				"absolute inset-0 h-svh overflow-y-auto pt-[4.5rem] pb-16 md:pb-0",
				className,
			)}
		>
			{children}
		</main>
	);
}

export { DashboardLayout };
